declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

const pushEvent = (event: string, params: Record<string, unknown> = {}): void => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export const pushPageView = (path: string, title: string): void => {
  pushEvent('virtual_page_view', {
    page_path: path,
    page_location: typeof window !== 'undefined' ? window.location.href : path,
    page_title: title,
  });
};
